<!-- @format -->
<pdf-tag>
    <input id="pdf-upload" type="file" accept='application/pdf,.pdf' onchange="{preview}" class="def-hidden">
    <div id="preview-area" class="def-hidden">
        <div id="pdf-del-button"
            class="button button-border button-secondary-mini"
            type="button"
            value="添付ファイルを削除する"
            onclick="{remove}"
            data-target=""
        >添付ファイルを削除する</div>{filename}
    </div>

    <script>
        import debounce from 'debounce-promise';
        import works from "@model/works/api";

        export default {
            works: works,
            filename:'',
	        fileReader: new FileReader(),
            preview(e) {
                const type = e.target.files[0].type.split('/')
                if ('pdf' != type[1]) {
                    return
                }
                this.filename = e.target.files[0].name
                this.works.trigger('preview-pdf')
                this.$('#preview-area').classList.remove('def-hidden')
                this.fileReader.readAsDataURL(e.target.files[0])
                this.props.onUpload(e.target.files[0])
                this.update()
            },
            remove(e) {
                this.works.work_action = 'delete'
                this.$('#pdf-upload').value = ''
                this.$('#preview-area').classList.add('def-hidden')
                this.props.onUpload(null)
            },
            listenerUploadPdf() {
                this.$('#pdf-upload').click()
            },
            listenerClear() {
                this.$('#pdf-upload').value = ''
            },
            onMounted(props, state) {
	            this.fileReader.onload = (()=> {
                    this.$('#preview-area').classList.remove('def-hidden')
                })
                this.works.on('upload-pdf', this.listenerUploadPdf)
                this.works.on('clear-pdf', this.listenerClear)
            },
            onUnmounted(props, state) {
                this.works.off('upload-pdf', this.listenerUploadPdf)
                this.works.off('clear-pdf', this.listenerClear)
            }
        }
    </script>
    <style>
        .canvas-size {
            max-width: 500px;
            margin-top: 12px;
        }
        .def-hidden {
            display: none;
        }
    </style>
</pdf-tag>